<template>

  <div class="vflex">

    <div class="vflex-row-0 vflex-header p-3">
      <div class="page-title">
        <div class="title">
          <h4>Pipeline Atual</h4>
        </div>
        <div>
          <div class="form-inline">
            <div class="form-group mr-2">
              <range-date-filter
                :value="rangeDate"
                @input="(v) => { setFilters({created_at: v}) }"
                style="min-width: 210px"> 
                </range-date-filter>
            </div>
            <button
              class="btn btn-light"
              @click="exportReport">
              {{ $t('Export xlsx') }}
              </button>
          </div>
        </div>
      </div>
    </div>

    <div class="vflex-row-1">

      <filterfy
        :models="filtersMap"
        :initFilters="filters"
        @changed="setFilters">

        <Paginaty
          :total="grid.total"
          :pages="grid.pages"
          :page="grid.page"
          :creating="creating"
          :loading="loading"
          @changePage="setPage">
          
          <template slot="content">
            <table class="table table-bordered">
              <thead class="thead-fixed">
                <tr>
                  <th class="text-truncate"></th>
                  <th class="text-truncate"></th>
                  <th class="text-truncate"></th>
                  <th class="text-truncate"></th>
                  <th class="text-truncate"></th>
                  <th class="text-truncate"></th>
                  <th class="text-truncate"></th>
                  <th class="text-truncate" colspan="3" v-for="stage in grid.stageNames">{{ stage.name }}</th>
                </tr>
              </thead>
              <thead>
                <tr>
                  <th-sort
                    field="title"
                    :value="sort"
                    @input="setSort">{{ $t('Job') }}</th-sort>
                  <th-sort
                    field="status"
                    :value="sort"
                    @input="setSort">{{ $t('Status') }}</th-sort>
                  <th-sort
                    field="company.name"
                    :value="sort"
                    @input="setSort">{{ $t('Company') }}</th-sort>
                  <th-sort
                    field="departament.name"
                    :value="sort"
                    @input="setSort">{{ $t('Department') }}</th-sort>
                  <th-sort
                    field="created_at"
                    :value="sort"
                    @input="setSort">{{ $t('Created at') }}</th-sort>
                  <th-sort
                    field="date_open"
                    :value="sort"
                    @input="setSort">{{ $t('Opening date') }}</th-sort>
                  <th-sort
                    field="date_close"
                    :value="sort"
                    @input="setSort">{{ $t('Expected closing date') }}</th-sort>
                  <template v-for="stage in grid.stageNames">
                  <th class="text-truncate">Atuais</th>
                  <th class="text-truncate">{{ $t('Disqualifieds') }}</th>
                  <th class="text-truncate">Entraram</th>
                  </template>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in grid.docs">
                  <th class="text-truncate"><router-link :to="{path: '/job/' + item._id }">{{ item.title }}</router-link> #{{ item.code }}</th>
                  <td class="text-truncate">{{ { open: 'Aberta', archived: 'Arquivada'}[item.status] }}</td>
                  <td class="text-truncate">{{ item.company.name }}</td>
                  <td class="text-truncate">{{ item.departament.name }}</td>
                  <td class="text-truncate">{{ $d(new Date(item.created_at), 'short') }}</td>
                  <td class="text-truncate">{{ $d(new Date(item.date_open), 'short') }}</td>
                  <td class="text-truncate">{{ $d(new Date(item.date_close), 'short') }}</td>
                  <template v-for="stage in grid.stageNames">
                  <td class="text-truncate" :class="getPipelineStage(item.pipeline, stage._id) ? '': 'table-secondary'">{{ getPipelineStage(item.pipeline, stage._id).qualified }}</td>
                  <td class="text-truncate" :class="getPipelineStage(item.pipeline, stage._id) ? '': 'table-secondary'">{{ getPipelineStage(item.pipeline, stage._id).disqualified }}</td>
                  <td class="text-truncate" :class="getPipelineStage(item.pipeline, stage._id) ? '': 'table-secondary'">{{ getPipelineStage(item.pipeline, stage._id).moved }}</td>
                  </template>
                </tr>
              </tbody>
            </table>
          </template>

          <template slot="noresults">
            {{ $t('There are no items') }}
          </template>

        </Paginaty>

      </filterfy>
      
    </div>
  </div>

</template>

<script>
import Filterfy from '@/components/Filterfy/Filterfy'
import ThSort from '@/components/Parts/ThSort'
import Paginaty from '@/components/Paginaty/Paginaty'
import RangeDateFilter from './RangeDateFilter'
import BlobDownload from '@/utils/BlobDownload'
import FilterfyToQuery from '@/utils/FilterfyToQuery'
import moment from 'moment'

export default {
  name: 'ReportPipelineSpeed',
  components: {
    Filterfy,
    ThSort,
    Paginaty,
    RangeDateFilter
  },
  data () {
    return {
      creating: true,
      loading: true,
      filtersMap: [
        {
          'type': 'list',
          'label': this.$t('Status'),
          'target': 'status',
          'resource': 'job_status'
        },
        {
          'type': 'list',
          'label': this.$t('Company'),
          'target': 'company_id',
          'resource': 'companies'
        },
        {
          'type': 'list',
          'label': this.$t('Department'),
          'target': 'departament_id',
          'resource': 'departaments'
        }
      ],
      grid: false
    }
  },
  computed: {
    filters () {
      return this.$route.query
    },
    sort () {
      return this.$route.query.sort || 'title'
    },
    rangeDate () {
      const defaultDate = `d|${moment().subtract(30, 'days').toISOString()}|${moment().toISOString()}`
      return this.$route.query.created_at === undefined ? defaultDate : this.$route.query.created_at
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    /*
    loadData
    */
    loadData () {
      this.loading = true

      const params = {
        ...FilterfyToQuery(this.filters, this.filtersMap),
        created_at: this.rangeDate,
        page: this.$route.query.page || 1,
        sort: this.sort,
        limit: this.$default.limit
      }

      this.axios
      .get('/accounts/' + this.$store.getters.getAccount._id + '/reports/current-pipeline', {params: params})
      .then((response) => {
        this.grid = response.data
        this.loading = this.creating = false
      })
    },
    /*
    setFilters
    */
    setFilters (filters) {
      this.$changeUrlParam(filters)
      this.setPage(1)
    },
    setSort (sort) {
      this.$changeUrlParam({sort: sort})
      this.setPage(1)
    },
    setPage (page) {
      this.$changeUrlParam({page: page})
      this.loadData()
    },
    getPipelineStage (pipeline, id) {
      let stage = false
      pipeline.forEach((v) => {
        if (v.stage_id === id) stage = v
      })
      return stage
    },
    exportReport () {
      const params = {
        ...this.filters,
        sort: this.sort
      }

      this.axios
      .get('/accounts/' + this.$store.getters.getAccount._id + '/reports/current-pipeline/export', {params: params, responseType: 'blob', timeout: 30000})
      .then((response) => {
        BlobDownload(response)
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Report/ReportCurrentPipeline.vue